<template>
  <div class="devcomp">
    <el-row>
      <el-col :span="24">
        <div class="search">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="选择时间">
              <el-date-picker v-model="excelTime" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="  ">

              <el-autocomplete v-model="searchsn" :fetch-suggestions="querySearchAsync" placeholder="请输入至少4位串号搜索"
                @select="onRefresh" @keyup.enter.native="onRefresh()">
                <template slot="prepend">设备串号IMEI：</template>
                <el-button slot="append" @click="onRefresh" icon="el-icon-search"></el-button>
              </el-autocomplete>
            </el-form-item>

            <el-form-item label=" 类型：">
              <el-select filterable @change="onRefresh" v-model="ssvalue" placeholder="请选择" style="width: 140px">
                <el-option v-for="item in sselect" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label=" 数量：">
              <el-input style="width: 80px" placeholder="1000" v-model="limit" maxlength=6 clearable
                @keyup.enter.native="onRefresh()">
              </el-input>
              点
            </el-form-item>
            <el-form-item label=" 偏移：">
              <el-input style="width: 80px" placeholder="0" v-model="offset" maxlength=6 clearable
                @keyup.enter.native="onRefresh()">
              </el-input>
              点
            </el-form-item>

            <el-form-item label="  ">
              <el-checkbox v-model="reverseFlag" @change="onRefresh">逆序</el-checkbox>
            </el-form-item>

            <el-form-item label="  ">
              <el-button type="success" @click="onRefresh" icon="el-icon-search">生成数据图表</el-button>
            </el-form-item>

          </el-form>

        </div>

        <div class="Echarts" style="margin:15px">
          <div id="chartmain" style="width: 100%; height: 700px"></div>
        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
      searchsn: "",//按SN查找
      reverseFlag: false,
      tbdata: {
        x: [],
        y: []
      },
      sselect: [
        {
          value: '净化温度',
          label: '净化温度'
        },
        {
          value: '仓内温度',
          label: '仓内温度'
        },
      ],
      ssvalue: '净化温度',
      limit: "1000",
      offset: "0",

      excelTime: [],
      pickerOptions: {
        disabledDate(time) {
          // 禁用2025年4月1日之前的日期
          const disabledDate = new Date('2025-09-01');
          return time.getTime() < disabledDate.getTime();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 366);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      myChart: {},
      option: {},

    }
  },
  created() {
    this.info = this.$store.state.userInfo
  },
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById('chartmain'))
    // this.updateEcharts()

  },
  beforeDestroy() {
  },
  methods: {

    //////
    // 主刷新
    async onRefresh() {
      let res = await this.$api.get_charts({
        sn: this.searchsn + "",
        status: this.ssvalue + "",
        start: this.excelTime[0] + "",
        end: this.excelTime[1] + "",
        limit: this.limit + "",
        offset: this.offset + "",
        reverse: this.reverseFlag,
      })
      console.log(res)
      if (res.status == 1) {
        this.tbdata = res.tbdata
        this.updateEcharts()
      }
    },
    updateEcharts() {
      // 指定图表的配置项和数据
      this.option = {
        title: {
          text: " 合计: " + this.tbdata.len + " 个数据点"
        },
        tooltip: {},
        legend: {
          data: [this.ssvalue]
        },
        xAxis: {
          data: this.tbdata.x
        },
        yAxis: {
          scale: true,
          minInterval: 1
        },
        series: [
          {
            name: this.ssvalue,
            type: 'line',
            data: this.tbdata.y
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(this.option)
    },
    async querySearchAsync(queryString, cb) {
      // 输入长度小于4时返回空结果
      if (queryString.length < 4 || queryString.length >= 15) {
        cb([]);
        return;
      }

      try {
        // 发起API请求
        const res = await this.$api.search_sn({
          sn: queryString + ""  // 确保参数为字符串类型
        });
        console.log(res);

        // 状态为1时直接使用返回的数据（已符合el-autocomplete要求的格式）
        if (res.status === 1) {
          cb(res.data);  // res.data格式为[{value: "xxx"}, {value: "yyy"}]
        } else {
          // 状态非1时返回空结果
          cb([]);
        }
      } catch (error) {
        console.error('搜索请求失败:', error);
        cb([]);  // 出错时返回空结果
      }
    },

    countFormatter(row, column, cellValue) {
      return cellValue + '次';
    },


  },
}
</script>

<style scoped>
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}


.detail-card .el-button {
  margin: 8px;
  margin-bottom: 14px;
  font-size: 16px;
  width: 92%
}
</style>
